<template>
  <span>
    <b-button v-if="isCreateMode"
              type="button"
              variant="success"
              @click="toggle"
    ><i class="fas fa-plus"></i> Create</b-button>

    <b-button v-else variant="primary" class="mr-1" size="xs" @click="toggle"><i class="fas fa-edit"></i>&nbsp;Edit</b-button>

    <b-modal
      @show="resetModal"
      @hidden="resetModal"
      ref="modal-container"
      v-model="modalShow"
      size="lg"
      :title="title"
      hide-footer
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-tabs content-class="mt-3">
          <b-tab title="Details" active>
            <b-form-group label="Full name" label-for="fullname-input">
              <b-form-input id="fullname-input" v-model="currencyForm.fullName" autocomplete="off" required></b-form-input>
            </b-form-group>
            <b-form-group label="Code" label-for="code-input">
              <b-form-input id="code-input" v-model="currencyForm.code"  autocomplete="off" required></b-form-input>
            </b-form-group>
            <b-form-group label="In EUR" label-for="ineur-input">
              <b-form-input id="ineur-input" v-model="currencyForm.toEUR" autocomplete="off" required></b-form-input>
            </b-form-group>
            <b-form-group label="Update Type" label-for="updatetype-input">
              <b-form-select id="updatetype-input" v-model="currencyForm.updateType" :options="updateTypeOptions" required></b-form-select>
            </b-form-group>
            <b-form-group label="Update Limit" label-for="limitupdatetype-input">
              <b-form-select id="limitupdatetype-input" v-model="currencyForm.limitUpdateType" :options="limitUpdateTypeOptions" required></b-form-select>
            </b-form-group>
            <b-form-group label="Type" label-for="type-input">
              <b-form-select id="type-input" v-model="currencyForm.type" :options="typeOptions" required></b-form-select>
            </b-form-group>

            <b-form-group v-if="!isCreateMode" label="Base currency code" label-for="parent-input">
              <multiselect v-model="currencyForm.parentCode" id="parent-input" label="code" track-by="code"
                           placeholder="Type to search"
                           :options="currencies"
                           :multiple="false"
                           :searchable="true"
                           :loading="currenciesIsLoading"
                           :internal-search="false"
                           :clear-on-select="false"
                           :close-on-select="true"
                           :max-height="600"
                           :show-no-results="true"
                           :options-limit="100"
                           :limit="1"
                           :hide-selected="false"
                           @search-change="asyncFindCurrencies"
              >
                <template slot="clear" slot-scope="props">
                  <div class="multiselect__clear" v-if="currencyForm.parentCode" @mousedown.prevent.stop="clearSelectedCurrencies(props.search)"></div>
                </template>
              </multiselect>
            </b-form-group>
            <b-form-group v-if="!isCreateMode" label="Multiplier" label-for="mul-input">
              <b-form-input id="mul-input" v-model="currencyForm.parentMultiplier" autocomplete="off"></b-form-input>
            </b-form-group>

            <b-form-group label="Fraction digits" label-for="inedigitsur-input">
              <b-form-input id="digits-input" v-model="currencyForm.fractionDigits" autocomplete="off"></b-form-input>
            </b-form-group>

          </b-tab>
        </b-tabs>
      </form>
      <b-button class="mt-2 float-right" variant="primary" @click="handleSubmit">Save</b-button>
    </b-modal>
  </span>
</template>

<style>
.multiselect__clear {
  position: absolute;
  right: 41px;
  height: 40px;
  width: 40px;
  display: block;
  cursor: pointer;
  z-index: 2;
}

.multiselect__clear:after, .multiselect__clear:before {
  content: "";
  display: block;
  position: absolute;
  width: 3px;
  height: 16px;
  background: #aaa;
  top: 12px;
  right: 4px;
}
.multiselect__clear:before {
  transform: rotate(45deg);
}
.multiselect__clear:after {
  transform: rotate(-45deg);
}
</style>
<script>
import Multiselect from 'vue-multiselect';
import * as CurrencyLimitUpdateTypes from '../../definitions/CurrencyLimitUpdateTypes'
import * as CurrencyUpdateTypes from '../../definitions/CurrencyUpdateTypes'
import * as CurrencyTypes from '../../definitions/CurrencyTypes'

const MODE_CREATE = 'create';

export default {
  data() {
    return {
      currencies: [],
      currencyForm: {},
      isCreateMode: true,
      modalShow: false,
      currenciesIsLoading: false,
      currenciesTimeout: null
    }
  },
  components: {
    Multiselect,
  },
  props: [
    'currency',
    'mode',
  ],
  methods: {
    clearSelectedCurrencies () {
      this.currencyForm.parentCode = null
    },
    asyncFindCurrencies (query) {
      this.currenciesIsLoading = true

      if (this.currenciesTimeout) {
        clearTimeout(this.currenciesTimeout);
      }

      this.currenciesTimeout = setTimeout(() => {
        this
          .$http({
            url: '/api/v1/currencies',
            params: {
              code: query,
              limit: 100,
              offset: 0,
              orderBy: 'code',
              direction: 'asc',
            },
            method: 'GET',
          })
          .then(resp => {
            this.currencies = resp.data.items;
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.currenciesIsLoading = false
          });
      }, 400);

    },
    checkFormValidity() {
      return this.$refs.form.checkValidity();
    },
    resetModal() {
      const c = this.currency || {}
      const updateTypeNum =
        c.updateType !== undefined && c.updateType !== null
          ? Number(c.updateType)
          : CurrencyUpdateTypes.MANUAL
      const limitUpdateTypeNum =
        c.limitUpdateType !== undefined && c.limitUpdateType !== null
          ? Number(c.limitUpdateType)
          : CurrencyLimitUpdateTypes.MANUAL

      this.currencyForm = {
        id: c.id,
        fullName: c.fullName != null ? c.fullName : '',
        code: c.code != null ? c.code : '',
        toEUR: c.toEUR != null ? c.toEUR : '',
        updateType: updateTypeNum,
        limitUpdateType: limitUpdateTypeNum,
        type:
          c.type !== undefined && c.type !== null
            ? Number(c.type)
            : CurrencyTypes.FIAT,
        fractionDigits:
          c.fractionDigits !== undefined && c.fractionDigits !== null
            ? c.fractionDigits
            : '',
        parentCode: c.parentCode ? { code: c.parentCode } : null,
        parentMultiplier:
          c.parentMultiplier !== undefined && c.parentMultiplier !== null
            ? c.parentMultiplier
            : ''
      }
    },
    hideModal() {
      this.$refs['modal-container'].hide();
    },
    toggle() {
      this.modalShow = !this.modalShow;
    },
    handleSubmit() {
      if (!this.checkFormValidity()) {
        return;
      }

      this
        .$http({
          url: this.isCreateMode ? '/api/v1/currencies' : '/api/v1/currencies/' + this.currency.code,
          data: {
            fullName: this.currencyForm.fullName,
            code: this.currencyForm.code,
            toEUR: this.currencyForm.toEUR,
            updateType: Number(this.currencyForm.updateType),
            limitUpdateType: Number(this.currencyForm.limitUpdateType),
            type: Number(this.currencyForm.type),
            fractionDigits:
              this.currencyForm.fractionDigits === '' ||
              this.currencyForm.fractionDigits === null ||
              this.currencyForm.fractionDigits === undefined
                ? null
                : parseInt(this.currencyForm.fractionDigits, 10),
            parentCode: this.currencyForm.parentCode ? this.currencyForm.parentCode.code : null,
            parentMultiplier:
              this.currencyForm.parentMultiplier === '' ||
              this.currencyForm.parentMultiplier === null ||
              this.currencyForm.parentMultiplier === undefined
                ? null
                : Number(this.currencyForm.parentMultiplier)
          },
          method: this.isCreateMode ? 'POST' : 'PUT'
        })
        .then(() => {
          setTimeout(() => {
            this.$emit('finish')
          }, 500);

          this.hideModal();
          this.$toastr.i('Success');
        })
        .catch((err) => {
          this.$toastr.e(JSON.stringify(err.response.data.message));

          throw err;
        });
    },
  },
  computed: {
    updateTypeOptions() {
      return [
        { value: CurrencyUpdateTypes.MANUAL, text: CurrencyUpdateTypes.TYPES[CurrencyUpdateTypes.MANUAL] },
        { value: CurrencyUpdateTypes.AUTO, text: CurrencyUpdateTypes.TYPES[CurrencyUpdateTypes.AUTO] },
        { value: CurrencyUpdateTypes.MULTIPLIER, text: CurrencyUpdateTypes.TYPES[CurrencyUpdateTypes.MULTIPLIER] }
      ]
    },
    limitUpdateTypeOptions() {
      return [
        { value: CurrencyLimitUpdateTypes.MANUAL, text: CurrencyLimitUpdateTypes.TYPES[CurrencyLimitUpdateTypes.MANUAL] },
        { value: CurrencyLimitUpdateTypes.AUTO, text: CurrencyLimitUpdateTypes.TYPES[CurrencyLimitUpdateTypes.AUTO] }
      ]
    },
    typeOptions() {
      return [
        { value: CurrencyTypes.CRYPTO, text: CurrencyTypes.TYPES[CurrencyTypes.CRYPTO] },
        { value: CurrencyTypes.FIAT, text: CurrencyTypes.TYPES[CurrencyTypes.FIAT] }
      ]
    },
    title() {
      if (this.isCreateMode) {
        return 'Create currency';
      } else {
        return 'Edit currency';
      }
    },
  },
  watch: {
  },
  mounted() {
    this.isCreateMode = this.mode === MODE_CREATE;
  },
}
</script>
